module.exports = __webpack_public_path__ + "static/img/allyoucaneat.46f768f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/allyoucaneat.png
// module id = 67RS
// module chunks = 1